$(() => {
  $(".dropdown-toggle").on("click", function() {
    return $(this).parent().find('.dropdown-list').toggle();
  });

  return $(".dropdown-select", $(".dropdown-list")).on("click", function() {
    let $dropdown_list = $(this).closest(".dropdown-list").toggle();

    return $dropdown_list.siblings(".dropdown-toggle").html($(this).html());
  });
});
